import { useMsal } from '@azure/msal-react';

const useLogout = () => {
    const { instance } = useMsal();

    const logout = () => {
        // Clear all local storage except for dark_mode
        Object.keys(localStorage).forEach(key => {
            if (key !== 'dark_mode') {
                localStorage.removeItem(key);
            }
        });

        instance.logoutRedirect({
            postLogoutRedirectUri: "/welcome",
        });
    };

    return logout;
};

export default useLogout;